import {
    ShowAllNAttachmentsWithSize,
    NAttachmentsWithSize,
    ShowAllNAttachments,
} from './getAttachmentWellInfoString.locstring.json';
import { NAttachments } from 'owa-locstrings/lib/strings/nattachments.locstring.json';
import loc, { format } from 'owa-localize';
import AttachmentWellViewState from 'owa-attachment-well-data/lib/schema/AttachmentWellViewState';
import { numberToByteQuantifiedStringConverter } from 'owa-file';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';

export default function getAttachmentWellInfoString(
    attachmentWell: AttachmentWellViewState,
    didViewOverflowOneRow: boolean,
    isShowingMultipleRows: boolean
): string {
    const attachmentCount: number =
        attachmentWell.docViewAttachments.length + attachmentWell.imageViewAttachments.length;
    const hasCloudyAttachments: boolean =
        attachmentWell.docViewAttachments.some(attachment => attachment.isCloudy) ||
        attachmentWell.imageViewAttachments.some(attachment => attachment.isCloudy);
    let totalSize: number = 0;
    if (!hasCloudyAttachments) {
        const reduceFunction = function (previousTotalSize, current) {
            const attachmentModel = getAttachment(current.attachmentId);
            return previousTotalSize + attachmentModel?.model.Size;
        };
        totalSize = attachmentWell.docViewAttachments.reduce(reduceFunction, 0);
        totalSize = attachmentWell.imageViewAttachments.reduce(reduceFunction, totalSize);
    }
    const appendShowAll = didViewOverflowOneRow && !isShowingMultipleRows;
    if (totalSize > 0) {
        const formatString = appendShowAll
            ? loc(ShowAllNAttachmentsWithSize)
            : loc(NAttachmentsWithSize);
        const totalSizeString = numberToByteQuantifiedStringConverter(totalSize);
        return format(formatString, attachmentCount, totalSizeString);
    } else {
        const formatString = appendShowAll ? loc(ShowAllNAttachments) : loc(NAttachments);
        return format(formatString, attachmentCount);
    }
}
